// import moment from 'moment'
import i18n from '../i18n'

const wpConfig = {
  host: 'https://wp.digitanz.de',
  api_base: '/wp-json',
  api_auth_base: '/jwt-auth/v1',
  api_wp_base: '/wp/v2'
}

// eslint-disable-next-line no-unused-vars
const wpFetch = (path, lang = 'de') => {
  const urlFull = wpConfig.host + wpConfig.api_base + path
  const url = new URL(urlFull)
  url.searchParams.append('lang', lang)
  return fetch(url.href)
}

const state = {
}

const actions = {
  getContent ({state}, {type, id, ...params}) {
    const path = `${wpConfig.host}${wpConfig.api_base}${wpConfig.api_wp_base}/${type}/${+(id)}`
    const url = new URL(path)
    params.lang = params.lang || i18n.locale
    Object.keys(params).forEach(k => {
      url.searchParams.append(k, params[k])
    })
    return fetch(url.href).then(r => r.json())
  },
  getContents ({state}, {type, ...params}) {
    const path = `${wpConfig.host}${wpConfig.api_base}${wpConfig.api_wp_base}/${type}`
    const url = new URL(path)
    params.lang = params.lang || i18n.locale
    Object.keys(params).forEach(k => {
      url.searchParams.append(k, params[k])
    })
    return fetch(url.href).then(r => r.json())
  }
}

export default {
  namespaced: true,
  state,
  actions
}



// WEBPACK FOOTER //
// ./src/store/wp-store.js